(function () {
  var initialized = new WeakSet();
  var observer = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      video.animationVisible = entry.isIntersecting;
      if (entry.isIntersecting) start(video, entry.boundingClientRect.width);
      else video.pause();
    });
  }, { rootMargin: '200px' }) : null;

  function fallback(video) {
    if (!video.isConnected) return;
    if (observer) observer.unobserve(video);
    var image = document.createElement('img');
    image.className = video.className;
    image.width = video.width;
    image.height = video.height;
    image.alt = video.getAttribute('aria-label') || '';
    image.loading = 'lazy';
    image.decoding = 'async';
    image.sizes = video.getAttribute('data-animation-fallback-sizes');
    image.srcset = video.getAttribute('data-animation-fallback-srcset');
    image.src = video.getAttribute('data-animation-fallback');
    video.replaceWith(image);
  }

  function start(video, width) {
    if (!video.isConnected) return;
    if (!video.poster) {
      // Use observer geometry rather than forcing layout; fetch the poster only near view.
      var pixels = (width || video.clientWidth) * (window.devicePixelRatio || 1);
      var candidate = pixels <= 480 ? 480 : pixels <= 640 ? 640 : 960;
      video.poster = video.getAttribute('data-animation-poster-' + candidate);
    }
    var source = video.querySelector('source[data-src]');
    if (source && !source.hasAttribute('src')) {
      source.src = source.getAttribute('data-src');
      video.load();
    }
    var playback = video.play();
    if (playback && playback.catch) playback.catch(function (error) {
      if (error.name !== 'AbortError' && video.animationVisible) fallback(video);
    });
  }

  function scan(root) {
    root.querySelectorAll('[data-lazy-animation]').forEach(function (video) {
      if (initialized.has(video)) return;
      initialized.add(video);
      video.addEventListener('error', function () { fallback(video); }, { once: true });
      if (!video.canPlayType('video/mp4')) return fallback(video);
      if (observer) observer.observe(video);
      else {
        video.animationVisible = true;
        start(video);
      }
    });
  }

  scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
